import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Page from './containers/page'
import { WithExperienceCheck as withExperienceCheck } from './utils/with-experience-check'

import { hasVisaPlusTreatment } from '../../js/experiments/visa-plus'
import { findRedirectPath } from '../../js/transfer/components/visa-plus/utils/route-check'

import {
  Onboard,
  Profile,
  NextSteps,
  ConfirmPhone,
  SendToApp,
} from './lazy-components'

const OnboardWithExperienceCheck = withExperienceCheck(Onboard, 'visaPlus')
const ProfileWithExperienceCheck = withExperienceCheck(Profile, 'visaPlus')
const NextStepsWithExperienceCheck = withExperienceCheck(NextSteps, 'visaPlus')

export default () => {
  // NOTE: The following experience check was based on some work done in ppmenodeweb
  // https://github.paypal.com/briwong/ppmenodeweb/blob/develop/client/src/screens/seller/with-experience-check.js
  // https://github.paypal.com/ConsumerWeb-R/ppmenodeweb/pull/2220/files

  const test = hasVisaPlusTreatment()

  // NOTE: This data should come from redux store
  // const eligibility = {
  //   evalResult: 'USER_ELIGIBLE',
  //   failedReason: '',
  //   suggestedActions: 'CREATE_VISA_PLUS_PROFILE',
  // }
  const eligibility = {}

  const onboardCheck = findRedirectPath('onboard', eligibility)
  const profileCheck = findRedirectPath('profile', eligibility)
  const nextStepsCheck = findRedirectPath('nextsteps', eligibility)

  return test ? (
    <Route path="/myaccount/transfer/visa-plus">
      <Page>
        <Switch>
          <VisaRoute
            exact
            path="/myaccount/transfer/visa-plus/onboard"
            component={OnboardWithExperienceCheck}
            customProps={{
              showExperience: onboardCheck.available,
              errorType: onboardCheck.errorMessageType,
            }}
          />
          <VisaRoute
            exact
            path="/myaccount/transfer/visa-plus/profile"
            component={ProfileWithExperienceCheck}
            customProps={{
              showExperience: profileCheck.available,
              errorType: profileCheck.errorMessageType,
            }}
          />
          <VisaRoute
            exact
            path="/myaccount/transfer/visa-plus/nextsteps"
            component={NextStepsWithExperienceCheck}
            customProps={{
              showExperience: nextStepsCheck.available,
              errorType: nextStepsCheck.errorMessageType,
            }}
          />
          <Route
            exact
            path="/myaccount/transfer/visa-plus/confirmphone"
            render={props => <ConfirmPhone {...props} />}
          />
          <Route
            exact
            path="/myaccount/transfer/visa-plus/sendtoapp"
            render={props => <SendToApp {...props} />}
          />
        </Switch>
      </Page>
    </Route>
  ) : null
}

/*
 *  Returns a Route object that renders the given Component.
 *  Why not just render the component normally you may ask?
 *  Well, this gives us a chance to redirect the user to a
 *  different route path WITHOUT doing all that messy logic
 *  within render() or <Switch>.  Theoretically this should
 *  be a redirect from the server side, but in case there is
 *  a situation where the server does not handle it, this
 *  would take of that.
 */

type VisaRouteProps = {
  component: React.Element | React.Component,
  customProps?: {
    showExperience?: boolean,
    errorType?: string,
  },
}

export function VisaRoute({
  component: Comp,
  customProps = {},
  ...props
}: VisaRouteProps) {
  return (
    <Route
      exact
      render={routerProps => (
        <>
          <Comp {...routerProps} {...customProps} />
        </>
      )}
      {...props}
    />
  )
}
